import React from 'react'
import styled from 'styled-components'
import OxygenModal, { ModalFooter, MODAL_FOOTER_ALIGN, MODAL_SIZE } from '@8x8/oxygen-modal'
import { hideDialog } from '~/actions/ui'

import { LARGE_LAYOUT_THRESHOLD, Z_INDEX } from '~/core/constants'
import ModalHeader from '~/components/dialogs/header'

const Content = styled.div`
  color: ${({ theme }) => theme._neo.textColor01};
  overflow-y: auto;
  height: 100%;
  padding: 0 24px 24px;
`

const StyledModal = styled(OxygenModal).attrs(({ theme }) => ({
  theme: {
    backgroundColor: theme.backgroundModal,
    color: theme.color
  }
}))`
  z-index: ${Z_INDEX.MODALS};

  [data-id="MODAL"] {
    ${({ isFullScreen }) => isFullScreen && `
      border-radius: 0;
      height: 100%;
      max-height: 100%;
      width: 100%;
    `}

    ${({ noPadding }) => noPadding && `
      ${Content} {
        padding: 0;
      }
    `}
  }

  @media (max-width: ${LARGE_LAYOUT_THRESHOLD}px) {
    [data-id="MODAL"] {
      border-radius: 0;
      height: 100%;
      max-height: 100%;
      width: 100%;
    }
  }
`

const Modal = ({
  allowOutsideClick = true,
  children,
  className,
  disableAutoFocus = true,
  footerChildren,
  noHeader,
  title,
  titleBadge,
  size = MODAL_SIZE.MEDIUM,
  ...rest
}) => {
  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      e.stopPropagation()
      hideDialog()
    }
  }

  return (
    <StyledModal
      className={className}
      disableAutoFocus={disableAutoFocus}
      allowOutsideClick={allowOutsideClick}
      size={size}
      onKeyDown={handleKeyDown}
      {...rest}
    >
      {!noHeader && <ModalHeader title={title} badge={titleBadge} />}
      <Content>
        {children}
      </Content>
      {footerChildren && (
        <ModalFooter align={MODAL_FOOTER_ALIGN.RIGHT}>
          {footerChildren}
        </ModalFooter>
      )}
    </StyledModal>
  )
}

export default Modal
